import React from 'react';
import { Breadcrumb } from 'antd';
import { useLocation } from 'react-router-dom';

const Breadcrumbs = () => {
  const location = useLocation();
  
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const pageTitle = pathSegments.length > 0 ? pathSegments[pathSegments.length - 1] : '';
  // const capitalizedTitle = pageTitle?.charAt(0).toUpperCase() + pageTitle?.slice(1);

  let translatedTitle = pageTitle;

  if (translatedTitle === 'transaction') {
    translatedTitle = 'Հաշվարկներ';
  } else if (translatedTitle === 'done') {
    translatedTitle = 'Կատարված';
  } else if (translatedTitle === 'add') {
    translatedTitle = 'Ավելացնել';
  } else if (translatedTitle === 'oil-done') {
    translatedTitle = 'Փոխարինված յուղերը';
  } else if (translatedTitle === 'cars') {
    translatedTitle = 'Մեքենաներ';
  } else if (translatedTitle === 'oil-blank') {
    translatedTitle = 'Յուղի բլանկ';
  } else if (translatedTitle === 'team') {
    translatedTitle = 'Մեր թիմը';
  }

  const homeTitle = 'Գլխավոր';
  const appTitle = 'Հարթակ';

  return (
    <Breadcrumb
      items={[
        {
          title: homeTitle,
        },
        {
          title: appTitle,
        },
        {
          title: translatedTitle,
        },
      ]}
      style={{
        margin: '16px 0',
      }}
    />
  );
};

export default Breadcrumbs;
